import React, { useState, useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import BulkEditSidebar from './BulkEditSidebar'

const BulkEditButton = ({ ensembleId, variables }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedResourceIds, setSelectedResourceIds] = useState([])
  const [allResourcesSelected, setAllResourcesSelected] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [totalResourceCount, setTotalResourceCount] = useState(0)

  useEffect(() => {
    const handleOpen = event => {
      const { resourceIds, allResources, searchQuery: query, totalResourceCount: total } = event.detail
      setSelectedResourceIds(resourceIds || [])
      setAllResourcesSelected(allResources || false)
      setSearchQuery(query || '')
      setTotalResourceCount(total || 0)
      setIsOpen(true)
    }

    document.addEventListener('openBulkEditSidebar', handleOpen)
    return () => document.removeEventListener('openBulkEditSidebar', handleOpen)
  }, [])

  const handleClose = useCallback(() => {
    setIsOpen(false)
  }, [])

  const handleSuccess = useCallback(notice => {
    const url = new URL(window.location.href)
    if (notice)
      url.searchParams.set('notice', notice)
    window.location.href = url.toString()
  }, [])

  return (
    <BulkEditSidebar
      allResourcesSelected={allResourcesSelected}
      ensembleId={ensembleId}
      isOpen={isOpen}
      searchQuery={searchQuery}
      selectedResourceIds={selectedResourceIds}
      totalResourceCount={totalResourceCount}
      variables={variables}
      onClose={handleClose}
      onSuccess={handleSuccess}
    />
  )
}

BulkEditButton.propTypes = {
  ensembleId: PropTypes.number.isRequired,
  variables: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired
}

export default BulkEditButton
